import { useEffect, useState } from "react";
import { fetchPageData } from "../endpoint/pageApi";
import MainLayout from "../layouts/MainLayout";
import boximg from "../assets/image/tempvideoboxforabout.png";
import icon1 from ".././assets/image/icon1.png";
import ShadowCard from "../components/ShadowCard/ShadowCard";
import PractitionersCrdBg from "../assets/image/PractitionersCrdBg.png";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../utils/mediaBreakpoints";
import PractitionersCarousel from "../components/Carousel/PractitionersCarousel";
import { baseUrl } from "../utils/base_url";
import { useNavigate } from "react-router-dom";

const MainPractitionersPage = ({ data }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });

  const navigate = useNavigate()


  return (
    <>
      <div
        className="container-fluid m-0 p-0"
        style={{ backgroundColor: " #090D24" }}
      >
        <div className="row">
          <div className="col-12 pt-4 pb-5">
            <div className="container px-0 contwidth">
              <PractitionersCarousel data={data} />

              <div className="text-center text-white">
                <p
                  className="fw700 "
                  style={{
                    fontSize: _576
                      ? "40px"
                      : _768
                      ? "45px"
                      : _992
                      ? "50px"
                      : _1200
                      ? "55px"
                      : _1400
                      ? "60px"
                      : _1600
                      ? "65px"
                      : _1700
                      ? "80px"
                      : _1800
                      ? "90px"
                      : "90px",
                  }}
                >
                  {data?.about_header?.heading}
                </p>
                <p
                  className={`fw700  p-0 w-100 ${
                    _1200 ? "pt-2" : _1400 ? "pt-0" : _1600 ? "pt-2" : "pt-3"
                  }`}
                  style={{
                    fontSize: _576
                      ? "20px"
                      : _768
                      ? "20px"
                      : _992
                      ? "20px"
                      : _1200
                      ? "25px"
                      : _1400
                      ? "30px"
                      : _1600
                      ? "30px"
                      : _1700
                      ? "35px"
                      : _1800
                      ? "40px"
                      : "40px",
                    lineHeight: _576
                      ? "1.5rem"
                      : _768
                      ? "1.5rem"
                      : _992
                      ? "1.5rem"
                      : _1200
                      ? "2rem"
                      : _1400
                      ? "2.5rem"
                      : _1600
                      ? "2.5rem"
                      : _1700
                      ? "2.6rem"
                      : _1800
                      ? "3.2rem"
                      : "3.2rem",
                    marginTop: "-1rem",
                  }}
                >
                  {data?.about_header?.sub_heading}
                </p>
              </div>
            </div>
          </div>

          {/* <div className="col-12">
            <div
              className={`row g-0 ${
                _768px ? "" : "d-flex align-items-center justify-content-center"
              }`}
              style={{ height: _768 ? "28vh" : "55vh" }}
            >
              {data?.column_view?.column_childs?.map((item, index) => {
                return (
                  <>
                    <div
                      className={`col-12 col-md-6 d-flex justify-content-center align-items-end pb-5`}
                      style={{
                        backgroundColor: item?.backgroundColor,
                        height: "100%",
                      }}
                    >
                      <p
                        className="text-white fw400 "
                        style={{
                          fontSize: _576
                            ? "40px"
                            : _768
                            ? "45px"
                            : _992
                            ? "45px"
                            : _1200
                            ? "50px"
                            : _1400
                            ? "55px"
                            : _1600
                            ? "55px"
                            : _1700
                            ? "60px"
                            : _1800
                            ? "60px"
                            : "60px",
                        }}
                      >
                        {item?.heading}
                      </p>
                    </div>
                  </>
                );
              })}
            </div>
          </div> */}
          <div className="col-12">
            <div
              className={`row g-0 ${
                _768px ? "" : "d-flex align-items-center justify-content-center"
              }`}
              style={{ height: _768 ? "28vh" : "55vh" }}
            >
              {data?.column_view?.column_childs?.map((item, index) => {
                const fontSize = _576
                  ? "30px"
                  : _768
                  ? "35px"
                  : _992
                  ? "40px"
                  : _1200
                  ? "45px"
                  : _1400
                  ? "50px"
                  : _1600
                  ? "55px"
                  : _1700
                  ? "60px"
                  : _1800
                  ? "65px"
                  : "60px";

                const isVideo = item?.image?.mime?.includes("video");
                const bgUrl = item?.image?.url
                  ? `${baseUrl}${item.image.url}`
                  : "";

                return (
                  <div
                    key={index}
                    className="col-12 col-md-6 position-relative d-flex justify-content-center align-items-end pb-5"
                    style={{
                      backgroundColor: item?.backgroundColor,
                      height: "100%",
                      backgroundImage: !isVideo ? `url(${bgUrl})` : undefined,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      overflow: "hidden",
                    }}
                  >
                    {/* Video background if applicable */}
                    {isVideo && (
                      <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                        style={{ zIndex: 0 }}
                      >
                        <source src={bgUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    )}

                    {/* Overlay content */}
                    <p
                      className="text-white fw400 position-relative"
                      style={{ fontSize, zIndex: 1 }}
                    >
                      {item?.heading}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="col-12" style={{ marginTop: _768 ? "10rem" : "" }}>
            <div className="position-relative overflow-hidden">
              <img
                src={PractitionersCrdBg}
                alt=""
                className="position-absolute start-50"
                style={{
                  top: _576 ? "50%" : _768 ? "50%" : _1500 ? "50%" : "51%",
                  transform: "translateX(-50%)",
                  height: "320px",
                  width: "100%",
                  zIndex: 0,
                  objectFit: "cover",
                  opacity: 0.5,
                }}
              />
              <div
                className="position-absolute start-50"
                style={{
                  top: _576 ? "50%" : _768 ? "50%" : _1500 ? "50%" : "51%",
                  transform: "translateX(-50%)",
                  height: "320px",
                  width: "100%",
                  backgroundColor: "#00165B",
                  mixBlendMode: "overlay",
                  pointerEvents: "none",
                  zIndex: 1,
                  opacity: 0.6,
                }}
              />
              <p
                className="fw400 text-white text-center position-relative px-3 px-md-0 lh-sm"
                style={{
                  padding: _768 ? `8rem 0` : "5rem 0",
                  lineHeight: "4rem",
                  fontSize: _576
                    ? "25px"
                    : _768
                    ? "35px"
                    : _992
                    ? "35px"
                    : _1200
                    ? "40px"
                    : _1400
                    ? "45px"
                    : _1600
                    ? "50px"
                    : _1700
                    ? "55px"
                    : _1800
                    ? "60px"
                    : "60px",
                }}
                dangerouslySetInnerHTML={{
                  __html: _768
                    ? data?.info_cards?.heading_1?.replace(
                        "with ASK FIDES.",
                        '<span style="border-bottom: 5px solid #0039EC " }}>with ASK FIDES.</span>'
                      )
                    : data?.info_cards?.heading_1
                        ?.replace("the next", "the next<br/>")
                        ?.replace(
                          "with ASK FIDES.",
                          '<span style="border-bottom: 5px solid #0039EC " }}>with ASK FIDES.</span>'
                        ),
                }}
              ></p>

              <div
                className="container contwidth"
                style={{
                  position: "relative",
                  zIndex: 1,
                  marginTop: _768 ? "3rem" : "10rem",
                  marginBottom: "7rem",
                }}
              >
                <div className="row">
                  <div className="col-12 d-flex flex-column gap-5 flex-lg-row align-items-center px-0">
                    {data?.info_cards?.details
                      ?.slice(0, 2)
                      // ?.map((card, index) => (
                      //   <div
                      //     className="d-flex align-items-start justify-content-between mb-5 mb-lg-0 px-2"
                      //     style={{
                      //       width: _768
                      //         ? "100%"
                      //         : _992
                      //         ? "50%"
                      //         : _1200
                      //         ? "50%"
                      //         : _1400
                      //         ? "40%"
                      //         : "33.33%",
                      //       height: _992
                      //       ? "max-content"
                      //       : _1600
                      //       ? "390px"
                      //       : _1700
                      //       ? "420px"
                      //       : _1800
                      //       ? "420px"
                      //       : "430px",
                      //     }}
                      //   >
                      //     <ShadowCard
                      //       isCrdWhite={false}
                      //       topIcon={card?.top_icon?.url}
                      //       text={card?.sub_heading}
                      //       topHeading={card?.heading}
                      //       textClass={`fw400 ${
                      //         _576
                      //           ? "fs18"
                      //           : _768
                      //           ? "fs20"
                      //           : _992
                      //           ? "fs18"
                      //           : _1200
                      //           ? "fs18"
                      //           : _1400
                      //           ? "fs16"
                      //           : _1500
                      //           ? "fs16"
                      //           : _1600
                      //           ? "fs16"
                      //           : _1700
                      //           ? "fs18"
                      //           : _1800
                      //           ? "fs18"
                      //           : "fs20"
                      //       }`}
                      //       headingClass={`fw800 ${
                      //         _576
                      //           ? "fs30"
                      //           : _768
                      //           ? "fs35"
                      //           : _992
                      //           ? "fs35"
                      //           : _1200
                      //           ? "fs28"
                      //           : _1400
                      //           ? "fs26"
                      //           : _1500
                      //           ? "fs28"
                      //           : _1600
                      //           ? "fs28"
                      //           : _1700
                      //           ? "fs32"
                      //           : _1800
                      //           ? "fs35"
                      //           : "fs40"
                      //       } `}
                      //       lineColor={card?.horizontal_line_color}
                      //       topIConHeight={card?.top_icon?.height}
                      //       topIConWidth={card?.top_icon?.width}
                      //       imgurl={card?.card_no?.url}
                      //     />
                      //   </div>
                      // ))}
                      ?.map((card, index) => (
                        <div onClick={()=>navigate(index===0?"/solo-practitioners":"/law-firms")}
                          className="cursor-pointer d-flex align-items-start justify-content-between mb-5 mb-lg-0 px-2"
                          // className="d-lg-flex flex-column flex-md-row align-items-md-start justify-content-between mb-5 mb-lg-0 px-2"
                          style={{
                            width: _768
                              ? "100%"
                              : _992
                              ? "50%"
                              : _1200
                              ? "50%"
                              : _1400
                              ? "40%"
                              : "33.33%",
                            height: _992
                              ? "max-content"
                              : _1600
                              ? "390px"
                              : _1700
                              ? "400px"
                              : _1800
                              ? "400px"
                              : "430px",
                          }}
                        >
                          <ShadowCard
                            isCrdWhite={false}
                            topIcon={card?.top_icon?.url}
                            text={card?.sub_heading}
                            topHeading={card?.heading}
                            textClass={`fw400 ${
                              _576
                                ? "fs18"
                                : _768
                                ? "fs20"
                                : _992
                                ? "fs18"
                                : _1200
                                ? "fs18"
                                : _1400
                                ? "fs16"
                                : _1500
                                ? "fs16"
                                : _1600
                                ? "fs16"
                                : _1700
                                ? "fs18"
                                : _1800
                                ? "fs18"
                                : "fs20"
                            }`}
                            headingClass={`fw800 ${
                              _576
                                ? "fs30"
                                : _768
                                ? "fs35"
                                : _992
                                ? "fs35"
                                : _1200
                                ? "fs28"
                                : _1400
                                ? "fs26"
                                : _1500
                                ? "fs28"
                                : _1600
                                ? "fs28"
                                : _1700
                                ? "fs32"
                                : _1800
                                ? "fs35"
                                : "fs40"
                            } `}
                            lineColor={card?.horizontal_line_color}
                            topIConHeight={card?.top_icon?.height}
                            topIConWidth={card?.top_icon?.width}
                            imgurl={card?.card_no?.url}
                          />
                        </div>
                      ))}
                    <div
                      style={{
                        width: _768
                          ? "0%"
                          : _992
                          ? "0%"
                          : _1200
                          ? "0%"
                          : _1400
                          ? "20%"
                          : "33.33%",
                        // height: "490px",
                      }}
                    ></div>
                  </div>
                </div>

                <p
                  className="fw700 text-white text-center py-4"
                  style={{
                    fontSize: _576
                      ? "30px"
                      : _768
                      ? "35px"
                      : _992
                      ? "35px"
                      : _1200
                      ? "35px"
                      : _1400
                      ? "40px"
                      : _1600
                      ? "45px"
                      : _1800
                      ? "50px"
                      : "60px",
                  }}
                >
                  {data?.info_cards?.heading_2}
                </p>

                <div className="row ">
                  <div className="col-12 gap-5 d-flex flex-column flex-lg-row align-items-center px-0">
                    <div
                      style={{
                        width: _768
                          ? "0%"
                          : _992
                          ? "0%"
                          : _1200
                          ? "0%"
                          : _1400
                          ? "20%"
                          : "33.33%",
                        // height: "490px",
                      }}
                    ></div>
                    {data?.info_cards?.details
                      ?.slice(2, 4)
                      ?.map((card, index) => (
                        <div onClick={()=>navigate(index===0?"/in-house-legal-teams":"/judges-and-law-clerks")}
                          className="cursor-pointer d-flex align-items-start justify-content-between mb-5 mb-lg-0 px-2"
                          // className="d-lg-flex flex-column flex-md-row align-items-md-start justify-content-between mb-5 mb-lg-0 px-2"
                          style={{
                            width: _768
                              ? "100%"
                              : _992
                              ? "50%"
                              : _1200
                              ? "50%"
                              : _1400
                              ? "40%"
                              : "33.33%",
                            height: _992
                              ? "max-content"
                              : _1600
                              ? "390px"
                              : _1700
                              ? "400px"
                              : _1800
                              ? "400px"
                              : "430px",
                          }}
                        >
                          <ShadowCard
                            isCrdWhite={false}
                            topIcon={card?.top_icon?.url}
                            text={card?.sub_heading}
                            topHeading={card?.heading}
                            textClass={`fw400 ${
                              _576
                                ? "fs18"
                                : _768
                                ? "fs20"
                                : _992
                                ? "fs18"
                                : _1200
                                ? "fs18"
                                : _1400
                                ? "fs16"
                                : _1500
                                ? "fs16"
                                : _1600
                                ? "fs16"
                                : _1700
                                ? "fs18"
                                : _1800
                                ? "fs18"
                                : "fs20"
                            }`}
                            headingClass={`fw800 ${
                              _576
                                ? "fs30"
                                : _768
                                ? "fs35"
                                : _992
                                ? "fs35"
                                : _1200
                                ? "fs28"
                                : _1400
                                ? "fs26"
                                : _1500
                                ? "fs28"
                                : _1600
                                ? "fs28"
                                : _1700
                                ? "fs32"
                                : _1800
                                ? "fs35"
                                : "fs40"
                            } `}
                            lineColor={card?.horizontal_line_color}
                            topIConHeight={card?.top_icon?.height}
                            topIConWidth={card?.top_icon?.width}
                            imgurl={card?.card_no?.url}
                          />
                        </div>
                      ))}
                    {/* <div
                      className="d-flex align-items-start justify-content-between bg-info p-2"
                      style={{
                        width: "464px",
                        height: "490px",
                      }}
                    >
                      <ShadowCard
                        isCrdWhite={false}
                        topIcon={data?.info_cards?.details?.top_icon?.url}
                        text={data?.info_cards?.details?.sub_heading}
                        topHeading={data?.info_cards?.details?.heading}
                        textClass={"fw400 fs20"}
                        headingClass={"fw800 fs40"}
                        lineColor={
                          data?.info_cards?.details?.horizontal_line_color
                        }
                        topIConHeight={
                          data?.info_cards?.details?.top_icon?.height
                        }
                        topIConWidth={
                          data?.info_cards?.details?.top_icon?.width
                        }
                      />
                    </div>
                    <div
                      style={{
                        width: "464px",
                        height: "490px",
                      }}
                      className="d-flex align-items-start justify-content-between bg-success p-2"
                    >
                      <ShadowCard
                        isCrdWhite={false}
                        topIcon={data?.info_cards?.details?.top_icon?.url}
                        text={data?.info_cards?.details?.sub_heading}
                        topHeading={data?.info_cards?.details?.heading}
                        textClass={"fw400 fs20"}
                        headingClass={"fw800 fs40"}
                        lineColor={
                          data?.info_cards?.details?.horizontal_line_color
                        }
                        topIConHeight={
                          data?.info_cards?.details?.top_icon?.height
                        }
                        topIConWidth={
                          data?.info_cards?.details?.top_icon?.width
                        }
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Practitioners = () => {
  const [pageData, setPageData] = useState({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchPageData(
      "pages?filters[slug][$eq]=practitioners",
      setPageData,
      setLoader
    );
  }, []);
  return (
    <>
      <MainLayout loader={loader}>
        <div className="container-fluid  p-0 overflow-x-hidden">
          <MainPractitionersPage data={pageData} />
        </div>
      </MainLayout>
    </>
  );
};

export default Practitioners;
